export enum InputFileNamePartType {
  CREATED_AT_DATE = 'CREATED_AT_DATE',
  CREATED_AT_TIME = 'CREATED_AT_TIME',
  DISPLAY_NAME = 'DISPLAY_NAME',
  FIELD = 'FIELD',
  RUN_API_ID = 'RUN_API_ID',
  RUN_ID = 'RUN_ID',
  RUN_SCHEMA_NAME = 'RUN_SCHEMA_NAME',
  SOURCE_FILE_NAME = 'SOURCE_FILE_NAME',
  TEXT = 'TEXT',
}

export type InputFileNamePart =
  | {type: InputFileNamePartType.CREATED_AT_DATE; datetimeFormat?: string}
  | {type: InputFileNamePartType.CREATED_AT_TIME; datetimeFormat?: string}
  | {type: InputFileNamePartType.DISPLAY_NAME}
  | {type: InputFileNamePartType.FIELD; fieldId: string; datetimeFormat?: string}
  | {type: InputFileNamePartType.RUN_API_ID}
  | {type: InputFileNamePartType.RUN_ID}
  | {type: InputFileNamePartType.RUN_SCHEMA_NAME}
  | {type: InputFileNamePartType.SOURCE_FILE_NAME}
  | {type: InputFileNamePartType.TEXT; text: string};
